module.exports = __webpack_public_path__ + "img/introduction-img@720w.16505772.png";